import { combineReducers } from '@reduxjs/toolkit';
import submitContactSlice from './contactSlice';
import submitContactSelfVerificationSlice from './contactSelfVerification';

export default combineReducers({
    contact: submitContactSlice,
    contactSubmitSelfVerification: submitContactSelfVerificationSlice,
});
